<template>
  <div class="notifications-bg">
    <div class="notifications-content">
      <div class="notifications-card">
        <div class="notifications-card-header">
          <span class="card-title">การแจ้งเตือน</span>
          <div class="noti-tabs">
            <div
              v-for="tab in tabs"
              :key="tab.key"
              :class="['noti-tab', { active: activeTab === tab.key }]"
              @click="activeTab = tab.key"
            >
              {{ tab.label }}
              <span v-if="getTabCount(tab.key) > 0" class="tab-number">{{ getTabCount(tab.key) }}</span>
            </div>
          </div>
        </div>
        
        <div v-if="loadingNotification" class="loading-container">
          <a-spin size="large" tip="กำลังโหลดข้อมูล..." />
        </div>
        
        <div v-else class="notifications-list">
          <div
            v-for="(item, idx) in filteredNotifications"
            :key="idx"
            class="noti-row-card"
            :class="{ unread: item.is_read == null || item.is_read == 2 }"
          >
            <!-- การเบิกเงินฉุกเฉิน -->
            <div v-if="item.modelname == 'ClaimExpense'" class="noti-content" @click="handleClaim(item.id)">
                <div class="noti-row-main">
                  <div class="noti-row-left">
                   <span class="noti-dot" v-if="item.is_read == null">●</span>
                    <span class="noti-title">แจ้งขออนุมัติเบิกเงินฉุกเฉิน ></span>
                  </div>
                </div>

                <div class="noti-desc">
                  มีคำขออนุมัติเบิกเงินฉุกเฉิน&nbsp;
                  จาก พนักงานขับรถ <span style="color: #2D52B2; font-weight: bold;">
                    {{ item?.driver?.firstname }} {{ item?.driver?.lastname }}
                  </span>&nbsp;
                  จำนวนขอเบิก: {{ item.amount }} เมื่อวันที่ {{ new Date(item.created_at).toLocaleDateString('en-GB') }}

                  <a-tooltip>                                          
                    <a style="display: flex; justify-content: center; align-items: center; transform: translateY(0);" 
                      @click.stop="checkbox_notification(item)">
                      <span class="material-symbols-outlined noti-delete" 
                            @click.stop="removeSingleNotification(item)" 
                            title="ลบแจ้งเตือน">
                        delete
                      </span>
                    </a>
                  </a-tooltip>
                </div>

                <div class="noti-footer">
                  <span class="noti-time">{{ dateTimeFormat(item.created_at) }}</span>
                </div>
              </div>

            <!-- การแจ้งเตือนรถ -->
              <div v-else-if="item?.isType" class="noti-content" @click="handleCar(item.id,item.isType)">
                  <div class="noti-row-main">
                    <div class="noti-row-left">
                     <span class="noti-dot" v-if= "item.is_read == null || item.is_read == 2">●</span>
                      <span class="noti-title" v-if="item?.isType != 'maintenance'">แจ้งเตือนวันหมดอายุ {{ item?.textDescription }} ></span>
                      <span class="noti-title" v-else>แจ้งเตือนวันตรวจสภาพรถประจำปี ></span>
                    </div>
                  </div>  

                  <div class="noti-desc">
                    <span v-if="item?.isType != 'maintenance'">กรมธรรม์ประกันภัย {{item.textDescription}} [{{ item?.noNumber }}]&nbsp;</span>
                    <span v-if="item?.isType != 'maintenance'">รถทะเบียน: {{ item.plate_no }} เบอร์รถ: {{ item.carNo }}&nbsp;</span>
                    <span v-else>ตรวจสภาพรถประจำปีรถ ทะเบียน: {{ item.plate_no }}&nbsp;</span>
                    <span v-if="item?.isType != 'maintenance'">จะหมดอายุในวันที่ {{ new Date(item.expireDate).toLocaleDateString('en-GB') }}</span>
                    <span v-else>เบอร์รถ: {{ item.carNo }} จะครบกำหนดในวันที่ {{ new Date(item.expireDate).toLocaleDateString('en-GB') }}</span> 
                    
                    <a-tooltip>                                          

                      <a style="display: flex; justify-content: center; align-items: center; transform: translateY(0);" 
                        @click.stop="checkbox_notification(item)">
                        <span class="material-symbols-outlined noti-delete" 
                              @click.stop="removeSingleNotification(item)" 
                              title="ลบแจ้งเตือน">
                          delete
                        </span>
                      </a>
                    </a-tooltip>
                  </div>

                  <div class="noti-footer">
                    <span class="noti-time">{{ dateTimeFormat(item.created_at) }}</span>
                  </div>
                </div>


            <!-- การอนุมัติลา - Admin -->
            <div v-else-if="item.modelname == 'LeaveAdmin'" class="noti-content" @click="handleLeaveAdmin(item.id)">
              <div class="noti-row-main">
                <div class="noti-row-left">
                 <span class="noti-dot" v-if= "item.is_read == null || item.is_read == 2">●</span>
                </div>
              </div>

              <div class="noti-desc">
                มีคำขอลางาน ประเภท: {{ leaveTypeList.find(type => type.id == item.leave_type_id)?.name }}&nbsp;
                วันที่ {{ new Date(item.time_start).toLocaleDateString('en-GB') }} - {{ new Date(item.time_end).toLocaleDateString('en-GB') }}&nbsp;
                {{ item.approve_status == 1 ? 'ได้รับการอนุมัติแล้ว' : 'ไม่ได้รับการอนุมัติ' }}

                <a-tooltip>                                          
                  <a style="display: flex; justify-content: center; align-items: center; transform: translateY(0);" 
                    @click.stop="checkbox_notification(item)">
                    <span class="material-symbols-outlined noti-delete" 
                          @click.stop="removeSingleNotification(item)" 
                          title="ลบแจ้งเตือน">
                      delete
                    </span>
                  </a>
                </a-tooltip>
              </div>

              <div class="noti-footer">
                <span class="noti-time">{{ dateTimeFormat(item.created_at) }}</span>
              </div>
            </div>
            
            <!-- การลางาน -->
            <div v-else-if="item.modelname == 'LeaveUser'" class="noti-content" @click="handleLeaveUser(item.id)">
              <div class="noti-row-main">
                <div class="noti-row-left">
                 <span class="noti-dot" v-if= "item.is_read == null || item.is_read == 2">●</span>
                  <span class="noti-title">
                    แจ้งขอลางาน {{ leaveTypeList.find(type => type.id == item.leave_type_id)?.name }} >
                  </span>
                </div>
              </div>

              <div class="noti-desc">
                มีคำขอลางาน ประเภท: {{ leaveTypeList.find(type => type.id == item.leave_type_id)?.name }}&nbsp;
                จาก พนักงาน <span style="color: #2D52B2; font-weight: bold;">{{ item?.user_name }}</span>&nbsp;
                วันที่ {{ new Date(item.time_start).toLocaleDateString('en-GB') }} - {{ new Date(item.time_end).toLocaleDateString('en-GB') }}

                <a-tooltip>                                          
                  <a style="display: flex; justify-content: center; align-items: center; transform: translateY(0);" 
                    @click.stop="checkbox_notification(item)">
                    <span class="material-symbols-outlined noti-delete" 
                          @click.stop="removeSingleNotification(item)" 
                          title="ลบแจ้งเตือน">
                      delete
                    </span>
                  </a>
                </a-tooltip>
              </div>

              <div class="noti-footer">
                <span class="noti-time">{{ dateTimeFormat(item.created_at) }}</span>
              </div>
            </div>       
            
            <!-- WithdrawAdmin -->
            <div v-else-if="item.modelname == 'WithdrawAdmin'" class="noti-content" @click="handleWithdrawAdmin(item.id)">
              <div class="noti-row-main">
                <div class="noti-row-left">
                 <span class="noti-dot" v-if= "item.is_read == null || item.is_read == 2">●</span>
                  <span class="noti-title">
                    แจ้งขอใช้โควตาการเบิกเงิน {{ leaveTypeList.find(type => type.id == item.leave_type_id)?.name }} >
                  </span>
                </div>
              </div>

              <div class="noti-desc">
                มีคำขอเบิกเงิน จำนวนขอเบิก: {{ item?.withdraw_user_amount }}&nbsp;
                จาก พนักงาน <span style="color: #2D52B2; font-weight: bold;">{{ item?.fullname }}</span>&nbsp;
                วันที่ {{ new Date(item.time_start).toLocaleDateString('en-GB') }}

                <a-tooltip>                                          
                  <a style="display: flex; justify-content: center; align-items: center; transform: translateY(0);" 
                    @click.stop="checkbox_notification(item)">
                    <span class="material-symbols-outlined noti-delete" 
                          @click.stop="removeSingleNotification(item)" 
                          title="ลบแจ้งเตือน">
                      delete
                    </span>
                  </a>
                </a-tooltip>
              </div>

              <div class="noti-footer">
                <span class="noti-time">{{ dateTimeFormat(item.created_at) }}</span>
              </div>
            </div>  

            <!-- WithdrawUser -->
            <div v-else-if="item.modelname == 'WithdrawUser'" class="noti-content" @click="handleWithdrawUser(item.id)">
              <div class="noti-row-main">
                <div class="noti-row-left">
                  <span class="noti-dot" v-if= "item.is_read == null || item.is_read == 2">●</span>
                  <span class="noti-title">
                    แจ้งขอใช้โควตาการเบิกเงิน {{ leaveTypeList.find(type => type.id == item.leave_type_id)?.name }} >
                  </span>
                </div>
              </div>

              <div class="noti-desc">
                มีคำขอเบิกเงิน จำนวนขอเบิก: {{ item?.withdraw_user_amount }}&nbsp;
                วันที่ {{ new Date(item.time_start).toLocaleDateString('en-GB') }} {{ item.withdraw_admins[0].approve_status == "1"? 'ได้รับการอนุมัติแล้ว' : 'ไม่ได้รับการอนุมัติ' }}
                หมายเหตุ: {{ item?.withdraw_admins[0].withdraw_admin_remark }}

                <a-tooltip>                                          
                  <a style="display: flex; justify-content: center; align-items: center; transform: translateY(0);" 
                    @click.stop="checkbox_notification(item)">
                    <span class="material-symbols-outlined noti-delete" 
                          @click.stop="removeSingleNotification(item)" 
                          title="ลบแจ้งเตือน">
                      delete
                    </span>
                  </a>
                </a-tooltip>
              </div>

              <div class="noti-footer">
                <span class="noti-time">{{ dateTimeFormat(item.created_at) }}</span>
              </div>
            </div>  

            <!-- ประเภทอื่น ๆ -->
            <div v-else class="noti-content">
              <div class="noti-row-main">
                <div class="noti-row-left">
                 
                  <span class="noti-title">แจ้งเตือนประเภทอื่น ๆ: {{ item.modelname }}</span>
                </div>
              </div>
              <div class="noti-desc">
                ยังไม่ได้กำหนด UI สำหรับ model นี้
                <a-tooltip>                                          
                <a style="display: flex; justify-content: center; align-items: center; transform: translateY(0);" @click="checkbox_notification(item)()">
                <span class="material-symbols-outlined noti-delete" @click="removeSingleNotification(item)" title="ลบแจ้งเตือน">delete</span></a>
                </a-tooltip>
              </div>
              <div class="noti-footer">
                <span class="noti-time">{{ dateTimeFormat(item.created_at) }}</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>  
import SystemService from '@/api/SystemService';
import VecaboService from '@/api/VecaboService';
import AdminService from '@/api/AdminService';
import ClaimExpenseService from '@/api/ClaimExpenseService';
import LeaveService from '@/api/LeaveService';
import CarService from '@/api/CarService';
import LeaveUserService from '@/api/LeaveUserService';
import LeaveAdminService from '@/api/LeaveAdminService';
import UserService from '@/api/UserService';
import CompanyService from '@/api/CompanyService';
import WithdrawUserService from '@/api/WithdrawUserService';
import WithdrawAdminService from '@/api/WithdrawAdminService';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

export default {
  name: "Notifications",
  data() {
    return {
      activeTab: "all",
      loadingNotification: false,
      combinedData: [],
      leaveTypeList: [],
      tabs: [
        { key: "all", label: "ทั้งหมด" },
        { key: "unread", label: "ยังไม่ได้อ่าน" },
        { key: "LeaveUser", label: "ลางานพนักงาน" },
        { key: "ClaimExpense", label: "เบิกเงินฉุกเฉิน" },
        { key: "Act", label: "พ.ร.บ" },
        /*{ key: "Tax", label: "ภาษี" },*/
        { key: "Insurance", label: "ประกันภัย" },
        { key: "Maintenance", label: "ตรวจสภาพรถ" },
        /*{ key: "mileage", label: "เปลี่ยนเลขไมล์" },*/
        { key: "Product", label: "ประกันภัยสินค้า" },
        
      ],
    };
  },
  computed: {
    filteredNotifications() {
  const validData = this.combinedData.filter(n => n.is_read != 0 && n.is_read != 9 && n.is_active_noti_admin != 0);
  
  let filtered = [];

  if (this.activeTab === "all") {
    filtered = validData;
  } else if (this.activeTab === "unread") {
    filtered = validData.filter((n) => n.is_read == null || n.is_read == 2);
  } else if (this.activeTab === "LeaveUser") {
    filtered = validData.filter((n) => n.modelname == "LeaveUser" || n.modelname === "leaveAdmin" || (n.work_status && !n.modelname));
  } else if (this.activeTab === "ClaimExpense") {
    filtered = validData.filter((n) => n.modelname === 'ClaimExpense' || n.modelname == "WithdrawAdmin" || n.modelname === "WithdrawUser");
  } else if (this.activeTab === "Act") {
    filtered = validData.filter((n) => n.isType && n.textDescription === 'พ.ร.บ.');
  } else if (this.activeTab === "Tax") {
    filtered = validData.filter((n) => n.isType && n.textDescription === 'ภาษี');
  } else if (this.activeTab === "Insurance") {
    filtered = validData.filter((n) => n.isType && n.textDescription === 'ประกันภัยรถ');
  } else if (this.activeTab === "Maintenance") {
    filtered = validData.filter((n) => n.isType && n.textDescription === 'ตรวจสภาพรถประจำปี');
  } else if (this.activeTab === "mileage") {
    filtered = validData.filter((n) => n.isType && n.textDescription === 'เปลี่ยนเลขไมล์');
  } else if (this.activeTab === "Product") {
    filtered = validData.filter((n) => n.isType && n.textDescription === 'ประกันภัยสินค้า');
  } else {
    filtered = validData.filter((n) => n.modelname === this.activeTab);
  }

  return filtered.sort((a, b) => {
    const aUnread = a.is_read == null || a.is_read == 2 ? 1 : 0;
    const bUnread = b.is_read == null || b.is_read == 2 ? 1 : 0;
    if (aUnread !== bUnread) return bUnread - aUnread;

    const dateA = new Date(a.updated_date || a.created_at);
    const dateB = new Date(b.updated_date || b.created_at);
    return dateB - dateA;
  });
}
  },
  methods: {
  getTabCount(tabKey) {
    if (!this.combinedData || this.combinedData.length === 0) return 0;
    const unreadData = this.combinedData.filter(n => n.is_read == null || n.is_read == 2);
    switch(tabKey) {
      case "unread":
        return unreadData.length;
      case "LeaveUser":
        return unreadData.filter(n => n.modelname === "LeaveUser").length;
      case "ClaimExpense":
        return unreadData.filter(n => n.modelname === 'ClaimExpense' ||  n.modelname === 'WithdrawAdmin' || n.modelname === 'WithdrawUser').length;
      case "Act":
        return unreadData.filter(n => n.isType && (n.textDescription === 'พ.ร.บ.' || n.isType === 'Act')).length;
      case "Tax":
        return unreadData.filter(n => n.isType && (n.textDescription === 'ภาษี' || n.isType === 'Tax')).length;
      case "Insurance":
        return unreadData.filter(n => n.isType && (n.textDescription === 'ประกันภัยรถ' || n.isType === 'Insurance')).length;
      case "Maintenance":
        return unreadData.filter(n => n.isType && (n.textDescription === 'ตรวจสภาพรถประจำปี' || n.isType === 'maintenance')).length;
      case "mileage":
        return unreadData.filter(n => n.isType && (n.textDescription === 'เปลี่ยนเลขไมล์' || n.isType === 'mileage')).length;
      case "Product":
        return unreadData.filter(n => n.isType && (n.textDescription === 'ประกันภัยสินค้า' || n.isType === 'Product')).length;
      default:
        return unreadData.filter(n => n.modelname === tabKey).length;
  }
},

  setModelName(item) {
      const desc = item.textDescription;

      if (!desc) return item;

      if (desc.includes("เบิกเงินฉุกเฉิน")) {
        item.modelname = "ClaimExpense";
      } else if (desc.includes("พ.ร.บ")) {
        item.modelname = "Act";
      } else if (desc.includes("ประกันภัยสินค้า")) {
        item.modelname = "Product";
      }else if (desc.includes("ภาษี")) {
        item.modelname = "Tax";
      }else if (desc.includes("ประกันภัย")) {
        item.modelname = "Insurance";
      }else if (desc.includes("ตรวจสภาพรถ")) {
        item.modelname = "Maintenance";
      }else if (desc.includes("เปลี่ยนเลขไมล์")) {
        item.modelname = "mileage";
      }else if (desc.includes("ลางานพนักงาน")) {
        item.modelname = "LeaveUser";
      } else {
        item.modelname = "Other";
      }

      return item;
  },
    formatToThaiMonth(date) {
      const formatDate = new Date(date);
      const thaiMonths = [
        "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
        "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."
      ];
      const monthIndex = formatDate.getMonth();
      return 'เดือน ' + thaiMonths[monthIndex];
    },
    
    dateTimeFormat(data) {
      const parsedDate = dayjs(data);
      dayjs.locale('th');
      const currentTime = dayjs();

      const hourDiff = currentTime.diff(parsedDate, 'hour');
      const minuteDiff = currentTime.diff(parsedDate, 'minute');

      if (hourDiff === 0 && minuteDiff < 60) {
        return minuteDiff + " นาทีที่ผ่านมา";
      } else if (hourDiff > 0 && hourDiff < 25) {
        return hourDiff + " ชั่วโมงที่ผ่านมา";
      } else {
        return parsedDate.format('D MMMM YYYY');
      }
    },
    
    async handleClaim(id){
      await ClaimExpenseService.isReadClaimExpenseId(id);
      
      this.$router.push('/app/claim').then(() => {
        window.location.reload();
      });
    },
    async handleLeave(id){
      await LeaveService.isReadLeaveId(id);
      
      this.$router.push('/app/leave').then(() => {
        window.location.reload();
      });
    },
    async handleLeaveUser(id){
      await LeaveUserService.isReadLeaveUserId(id);
      
      this.$router.push('/app/leaveAdmin/all').then(() => {
        window.location.reload();
      });
    },
    async handleLeaveAdmin(id){
      await LeaveAdminService.isReadLeaveAdminId(id);
      
      this.$router.push('/app/leaveUser/all').then(() => {
        window.location.reload();
      });
    },
    async handleWithdrawUser(id){
    
      await SystemService.update_all('WithdrawUser', { data: { is_read: 1 } }, id);
      
      this.$router.push('/app/withdrawUser/all').then(() => {
        window.location.reload();
      });
    },
    async handleWithdrawAdmin(id){
      await SystemService.update_all('WithdrawAdmin', { data: { is_read: 1 } }, id);
      this.$router.push('/app/withdrawAdmin/all').then(() => {
        window.location.reload();
      });
    },
    async handleCar(id,expireType){
 
      await CarService.isReadNotificationCarId(id,expireType);
      
      this.$router.push('/app/Car/'+id).then(() => {
       window.location.reload();
      });
    },

     async checkbox_notification(item) {
      if (this.checkId.length) {
        this.removeSingleNotification(item);
      } else {
        this.showCheckbox = !this.showCheckbox;
      }
    },
    async removeSingleNotification(item) {
      
      const index = this.combinedData.findIndex(n => n.id === item.id);
      if (index === -1) return;

      let days = 99;
      if (this.combinedData[index].isType) {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const expireDate = new Date(this.combinedData[index].expireDate);
        expireDate.setHours(0, 0, 0, 0);
        const timeDifference = expireDate - currentDate;
        days = timeDifference / (1000 * 60 * 60 * 24);
      }

      const arrayDelNoti = [{
        id: this.combinedData[index].id,
        isType: this.combinedData[index].isType
          ? this.combinedData[index].isType
          : this.combinedData[index].modelname === 'ClaimExpense'
            ? "claimExpenses"
            : this.combinedData[index].modelname === 'LeaveUser'
              ? "leaveUser"
              : this.combinedData[index].modelname === 'LeaveAdmin'
                ? "leaveAdmin"
                : this.combinedData[index].modelname === 'Act'
                  ? "act"
                  : this.combinedData[index].modelname === 'Tax'
                    ? "tax"
                    : this.combinedData[index].modelname === 'Insurance'
                      ? "insurance"
                      : this.combinedData[index].modelname === 'Maintenance'
                        ? "maintenance"
                        : this.combinedData[index].modelname === 'Mileage'
                          ? "mileage"
                          : this.combinedData[index].modelname === 'Product'
                            ? "product"
                            : this.combinedData[index].modelname === 'WithdrawUser'
                              ? "withdrawUser"
                              : this.combinedData[index].modelname === 'WithdrawAdmin'
                                ? "withdrawAdmin"
                                : "leave",
                            
                            
                            
        typeUser: this.combinedData[index].isType
          ? (days <= 30 ? "Admin2" : "Admin")
          : "Admin",
      }];

      await ClaimExpenseService.unActiveNotification(arrayDelNoti);
      this.combinedData.splice(index, 1);
    },
    
async initNotification() {
  this.loadingNotification = true;
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  this.leaveTypeList = await SystemService.get_core('getLeaveType')
  const data = await UserService.get_user_profile();
  const businessTypeId = await CompanyService.getBusinessId(data.company_id);
  if(businessTypeId.data != 3){
    if(data.permission?.role == "admin" || data.permission?.role == "administrative"){
      let claimNotFilter = await ClaimExpenseService.getClaimExpense();
      this.claimData = claimNotFilter?.filter((item) => item.is_active_noti_admin != 0 && item.approve == 0);
      
      const leaveDataNotFilter = await LeaveService.getLeaveDriver('WAITING');
      this.leavesData = leaveDataNotFilter.filter((item)=> item.is_active_noti_admin != 0);
      
      var LeaveUser = await LeaveUserService.getLeaveUserNotiByCompany();
      LeaveUser = LeaveUser
        .map((item) => {
          return {
            ...item,
            user_name: item.accountings_fullname
              ? item.accountings_fullname
              : item.administratives_fullname
              ? item.administratives_fullname
              : item.operations_fullname
              ? item.operations_fullname
              : item.human_resources_fullname
              ? item.human_resources_fullname
              : item.admins_firstname + " " + item.admins_lastname,
          };
        });
      this.leavesUserData = LeaveUser.filter((item)=> item.is_active_noti_admin != 0 && item.send_status == 1);
      this.leavesUserData = this.leavesUserData
        .map((item) => {
          return {
            ...item,
            created_at: item.updated_at,
          };
        });
      
      this.getCarNoti = await CarService.getNotificationCar();
      this.combinedData = [...this.claimData, ...this.leavesData,...this.getCarNoti,...this.leavesUserData];
    } 
    else if (data.permission?.role == "operation" || data.permission?.role == "accounting"){
      this.getCarNoti = await CarService.getNotificationCar();
      const leaveApproveNotFilter = await SystemService.get_core('getLeaveAdminProgressTwo')
      this.leaveApproveList = leaveApproveNotFilter
        .filter((item)=>item.approve_status != null && item.is_active_noti_admin != 0 && item.user_name == data.username)
        .map((item) => {
          return {
            ...item,
            updated_date: item.approved_date?item.approved_date:item.created_at
          };
        });
      this.combinedData = [...this.getCarNoti,...this.leaveApproveList];
    }
  }
  else{
    if(data.permission?.role == "admin" || data.permission?.role == "administrative"){
      this.getCarNoti = await CarService.getNotificationCar();
      
      var LeaveUser = await LeaveUserService.getLeaveUserNotiByCompany();
      LeaveUser = LeaveUser
        .map((item) => {
          return {
            ...item,
            user_name: item.accountings_fullname
              ? item.accountings_fullname
              : item.administratives_fullname
              ? item.administratives_fullname
              : item.operations_fullname
              ? item.operations_fullname
              : item.human_resources_fullname
              ? item.human_resources_fullname
              : item.admins_firstname + " " + item.admins_lastname,
          };
        });
      this.leavesUserData = LeaveUser.filter((item)=> item.is_active_noti_admin != 0 && item.send_status == 1);
      this.leavesUserData = this.leavesUserData
        .map((item) => {
          return {
            ...item,
            created_at: item.updated_at,
          };
        });
      
      this.combinedData = [...this.getCarNoti,...this.leavesUserData];
    } 
    else if(data.permission?.role == "operation" || data.permission?.role == "humanresource" || data.permission?.role == "accounting"){
      this.getCarNoti = await CarService.getNotificationCar();
      
      const leaveApproveNotFilter = await SystemService.get_core('getLeaveAdminProgressTwo')
      this.leaveApproveList = leaveApproveNotFilter
        .filter((item)=>item.approve_status != null && item.is_active_noti_admin != 0 && item.user_name == data.username)
        .map((item) => {
          return {
            ...item,
            updated_date: item.approved_date?item.approved_date:item.created_at
          };
        });
      
      if(data.permission?.role == 'humanresource'){
        let claimNotFilter = await ClaimExpenseService.getClaimExpense();
        this.claimData = claimNotFilter?.filter((item) => item.is_active_noti_admin != 0 && item.approve == 0);
      }
      
      if(data.permission?.role == 'operation'){
        const leaveDataNotFilter = await LeaveService.getLeaveDriver('WAITING');
        this.leavesData = leaveDataNotFilter.filter((item)=> item.is_active_noti_admin != 0);
      }
      
      this.combinedData = [
        ...this.getCarNoti,
        ...this.leaveApproveList,
        ...(this.claimData || []),
        ...(this.leavesData || [])
      ];
    }
    
    if(data.permission?.role == "operation" || data.permission?.role == "humanresource" || data.permission?.role == "accounting"){
      const withdrawUser = await WithdrawUserService.getWithdrawUserByCompany();
      const withdrawUserData = withdrawUser.filter(item => item.withdraw_admins[0]?.withdraw_progress == 2 && item.user_name == data.username)
        .map((item) => {
          return {
            ...item,
            updated_date: item.withdraw_admins[0]?.approved_date ? item.withdraw_admins[0].approved_date : item.created_at
          };
        });
      this.combinedData.push(...withdrawUserData);
    }
    
    if (data.permission?.role == "humanresource") {
      const withdrawAdmin = await WithdrawAdminService.getWithdrawAdminAll();
      const withdrawAdminProgress2Data = withdrawAdmin.filter(item => item.withdraw_user?.send_status == 1)
        .map((item) => {
          return {
            ...item,
            updated_date: item?.withdraw_user?.approved_date ? item?.withdraw_user?.approved_date : item.created_at
          };
        });
      this.combinedData.push(...withdrawAdminProgress2Data);
    }
  }
  
  // Sort และ Filter ข้อมูล
  if(this.combinedData.length > 0){
    this.combinedData.sort((a, b) => {
      if(a.updated_date || b.updated_date){
        const dateA = new Date(a.updated_date ? a.updated_date : a.created_at);
        const dateB = new Date(b.updated_date ? b.updated_date : b.created_at);
        return dateB - dateA;
      } else {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateB - dateA;
      }
    });
    
    this.combinedData = this.combinedData.filter((item)=>{
      const createdDate = new Date(item.created_at);
      createdDate.setHours(0, 0, 0, 0);
      const timeDiff = (currentDate - createdDate) / (1000 * 60 * 60 * 24);
      return timeDiff < 30;
    })
    
    this.badgeCountNoti = this.combinedData.filter((cData)=> cData.is_read == null || cData.is_read == 2).length;
  }
  
  this.loadingNotification = false;
}
  },
  
  async mounted() {
    await this.initNotification();
    this.notifications = this.notifications?.map(this.setModelName);
  },

};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:wght@100;200;300;400;500;600;700;800;900&display=swap');
.notifications-bg {
  background: #f8f8f8;
  min-height: 100vh;
  padding: 0;
  
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
}

.notifications-content {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.notifications-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px #0001;
  padding: 0 0 24px 0;
  width: 100%;
  max-width: 1850px;
  min-height: 600px;
}

.notifications-card-header {
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 32px 0 32px;
  gap: 12px;
}

.card-title {
  font-size: 25px;
  color: #000000;
}


.noti-tabs {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.noti-tab {
  font-size: 18px;
  color: #000000;
  padding: 5px 13px;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;       
  align-items: center;        
  gap: 6px;                   
  position: relative;    
}

.noti-tab.active {
  display: flex;
  gap: 0;
  border-bottom: 3px solid #2563EB;
  overflow-x: auto;
  padding-bottom: 0;
}

.notifications-list {
  margin-top: 0px;
  padding: 0 32px;
}

.noti-row-card.unread {
  background: #E9F6FE;
  display: flex;
  gap: 0;
  border-bottom: 2px solid #4177eb;
  overflow-x: auto;
  padding-bottom: 0;
}

.noti-content {
  width: 100%;
}

.noti-row-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.noti-row-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.noti-dot {
  color: #E53935;
  font-size: 35px;
  margin-right: -20px;
  margin-left: 20px;
  min-width: 10px;
  height: 60px;
}

.noti-title {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  flex: 1;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
  margin-left: 25px;
}

.noti-delete {
  font-size: 25px;
  color: #2563EB;
  cursor: pointer;
  position: absolute;
  right: 20px;       
  top: 50%;
  transform: translateY(-50%);
  z-index: 10; 
  padding: 5px; 
  user-select: none; 
  transition: all 0.2s ease; 
}


.noti-delete:hover {
  color: #E53935;
  background: #f5f5f5;
  border-radius: 4px;
}

.noti-desc {
  position: relative; 
  font-size: 15px;
  color: #222;
  margin-bottom: 5px;
  line-height: 1.2;
  margin-top: 0;
  margin-left: 24px;
   padding-right: 60px;
}

.noti-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  margin-left: 24px;
}

.noti-time {
  font-size: 15px;
  color: #1D39C4;
  font-weight: 500;
}

.detailCheck {
  font-size: 12px;
  background-color: white;
  border: 0.5px solid #ccc;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  height: 28px;
  line-height: 1;
}
.detailCheck {
  margin-left: auto;   
  cursor: pointer;
  color: #2563EB;
  font-weight: bold;
  user-select: none;
}
.noti-row-card {
   background: #fff;          
  border-top: 1px solid #bdbdbd9f;    
  border-bottom: 1px solid #bdbdbd9f; 
  border-left: none;            
  border-right: none;            
  border-radius: 0;             
  padding: 16px 0;             
}

/* Responsive design */
@media (max-width: 768px) {
  .notifications-card {
    margin: 12px;
    border-radius: 12px;
  }
  
  .notifications-card-header {
    padding: 16px 20px 0 20px;
  }
  
  .notifications-list {
    padding: 0 20px;
  }
  
  .noti-tabs {
    overflow-x: auto;
    padding-bottom: 4px;
  }
  
  .noti-desc, .noti-footer {
    margin-left: 20px;
  }
}
.tab-number {
  background: #2563EB;
  color: white;
  font-size: 13px;
  width: 24px;             
  height: 24px;
  border-radius: 50%;      
  display: flex;
  align-items: center;     
  justify-content: center;  
  font-weight: bold;
  line-height: 1;           
  flex-shrink: 0;           
}
</style>